import React, { Suspense, useState } from 'react';
import { Route, Switch } from 'react-router';

import { CurrentModal } from './components/CurrentModal';
import { ModalContext, Modals } from '../../modalsContext';

import { Loader } from '../Loader';
import { SuccessModal } from '../DepositStatusModal/components/SuccessModal';
import { FailedModal } from '../DepositStatusModal/components/FailedModal';

interface Props {
  onRequestClose: () => void;
  onSuccessButtonClick: (() => void) | undefined;
}

export const DepositModal: React.FC<Props> = ({ onRequestClose, onSuccessButtonClick }) => {
  const [currentOpenModal, setCurrentModalOpen] = useState(Modals.MAIN);

  return (
    <Switch>
      <Route path="/success">
        <Suspense fallback={<Loader />}>
          <SuccessModal onButtonClick={onSuccessButtonClick} onRequestClose={onRequestClose} />
        </Suspense>
      </Route>

      <Route path="/failure">
        <Suspense fallback={<Loader />}>
          <FailedModal onRequestClose={onRequestClose} />
        </Suspense>
      </Route>

      <Route path="/">
        <ModalContext.Provider
          value={{
            currentOpenModal,
            setCurrentModalOpen,
            onRequestClose,
          }}
        >
          <CurrentModal />
        </ModalContext.Provider>
      </Route>
    </Switch>
  );
};
